import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { COMPONENT_CALLER_TYPE } from 'commons/constants';
import usePdpId from '@/components/consumer/PDP/state/context/usePdpId';
import usePDPOptions from 'components/consumer/PDP/state/context/usePDPOptions';
import usePDPClearanceData from 'data-hooks/useClearanceData/usePDPClearanceData';
import usePDPBasicDetails from 'components/consumer/PDP/state/context/usePDPBasicDetails';
import useProductLabelOverride from '@/hooks/useProductLabelOverride';
const usePDPProductLabel = (id, slug, t0) => {
  const $ = _c(12);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const hookOptions = t1;
  const {
    productSku
  } = hookOptions;
  let t2;
  if ($[2] !== productSku) {
    t2 = {
      skipPDPStateHook: false,
      productSku
    };
    $[2] = productSku;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const {
    loading: basicLoading,
    error: basicError,
    data: basicData
  } = usePDPBasicDetails(id, slug, t2);
  const productOptionData = usePDPOptions();
  const {
    loading: optionsLoading,
    error: optionsError,
    data: optionsData
  } = productOptionData;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      callerType: COMPONENT_CALLER_TYPE.PDP
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const {
    error: clearanceDataError,
    data: clearanceData
  } = usePDPClearanceData(id, slug, t3);
  const {
    isClearance
  } = clearanceData;
  const pdpId = usePdpId();
  const labelOverride = useProductLabelOverride(pdpId);
  basicData?.custom_properties?.product_label;
  optionsData?.stock?.isSelectedOptionsQuickship;
  optionsData?.stock?.selectedOptionsStockQty;
  let label = null;
  if (optionsData?.stock?.isSelectedOptionsQuickship && optionsData.stock.selectedOptionsStockQty <= 3) {
    label = "Low Stock";
  }
  if (isClearance) {
    label = "Final Sale";
  }
  if (basicData?.custom_properties?.product_label?.[0]) {
    label = basicData?.custom_properties?.product_label;
  }
  const ownLabel = label;
  const productLabel = labelOverride?.label ?? ownLabel;
  const t4 = basicLoading || optionsLoading;
  const t5 = basicError || optionsError || clearanceDataError;
  const t6 = labelOverride?.color;
  let t7;
  if ($[5] !== productLabel || $[6] !== t6) {
    t7 = {
      productLabel,
      productLabelColor: t6
    };
    $[5] = productLabel;
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== t4 || $[9] !== t5 || $[10] !== t7) {
    t8 = {
      loading: t4,
      error: t5,
      data: t7
    };
    $[8] = t4;
    $[9] = t5;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  return t8;
};
export default usePDPProductLabel;